// Generated from SVG to Code Figma Plugin
import type React from 'react';
import { forwardRef } from 'react';

export const ProductLineTransform = forwardRef<
  SVGSVGElement,
  React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
>((props, ref) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <path
      d="M6.8563 10.279C8.74985 10.279 10.2849 8.74399 10.2849 6.85045C10.2849 4.9569 8.74985 3.42188 6.8563 3.42188C4.96276 3.42188 3.42773 4.9569 3.42773 6.85045C3.42773 8.74399 4.96276 10.279 6.8563 10.279Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M12 22C6.47716 22 2 17.5229 2 12L5.33331 13.6666"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M12 2.00391C17.5229 2.00391 22 6.48106 22 12.0039L18.6667 10.3373"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <rect
      height="6.42773"
      width="6.42773"
      rx="1.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      x="13.9277"
      y="13.9219"
    />
  </svg>
));

// Add display name for better debugging
ProductLineTransform.displayName = 'ProductLineTransform';
